import { render, staticRenderFns } from "./CourseBuilderVideoForm.vue?vue&type=template&id=0a1a5bfc&scoped=true&"
import script from "./CourseBuilderVideoForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderVideoForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderVideoForm.vue?vue&type=style&index=0&id=0a1a5bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a5bfc",
  null
  
)

export default component.exports